import '.a{display:flex;}.ssr-plugin'
import '.ad{align-items:stretch;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.d4{background:var(--shades-white);}.ssr-plugin'
import '.by{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.b1{max-width:77.5rem;}.ssr-plugin'
import '.d5{justify-content:stretch;}.ssr-plugin'
import '.d6{position:sticky;}.ssr-plugin'
import '.co{top:0;}.ssr-plugin'
import '.d7{z-index:10;}.ssr-plugin'
import '.d8{padding-block:1rem;}.ssr-plugin'
import '.d9{height:3rem;}.ssr-plugin'
import '.v{justify-content:space-between;}.ssr-plugin'
import '.da{flex-wrap:wrap;}.ssr-plugin'
import '.db{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bh{margin-top:2rem;}.ssr-plugin'
import '.dc{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ad g b d4"
      >
        <div className="by a c g b"
        >
          <div className="b1 a b d5 d6 co d7 d4"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="d8 d9 a v c da"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="db a b ad bh dc b1"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
